var map = {
	"./AC.svg": "8562",
	"./AD.svg": "1db8",
	"./AE.svg": "8109",
	"./AF.svg": "25fa",
	"./AG.svg": "0500",
	"./AI.svg": "ea0d",
	"./AL.svg": "0643",
	"./AM.svg": "a9e8",
	"./AO.svg": "49b0",
	"./AQ.svg": "f643",
	"./AR.svg": "f8e9",
	"./AS.svg": "a42a",
	"./AT.svg": "146e",
	"./AU.svg": "7f42",
	"./AW.svg": "2338",
	"./AX.svg": "76d9",
	"./AZ.svg": "e927",
	"./BA.svg": "e459",
	"./BB.svg": "e345",
	"./BD.svg": "1652",
	"./BE.svg": "28e9",
	"./BF.svg": "d685",
	"./BG.svg": "d28f",
	"./BH.svg": "5a8a",
	"./BI.svg": "d59e",
	"./BJ.svg": "a225",
	"./BL.svg": "5b1e",
	"./BM.svg": "36d8",
	"./BN.svg": "e5ab",
	"./BO.svg": "0105",
	"./BQ-BO.svg": "ac36",
	"./BQ-SA.svg": "5bd8",
	"./BQ-SE.svg": "459b",
	"./BQ.svg": "cf01",
	"./BR.svg": "ff84",
	"./BS.svg": "13a6",
	"./BT.svg": "1c95",
	"./BV.svg": "5663",
	"./BW.svg": "6232",
	"./BY.svg": "2123",
	"./BZ.svg": "791c",
	"./CA.svg": "eefe",
	"./CC.svg": "ca98",
	"./CD.svg": "d4a9",
	"./CF.svg": "b1e5",
	"./CG.svg": "212b",
	"./CH.svg": "fdff",
	"./CI.svg": "bcb5",
	"./CK.svg": "37db",
	"./CL.svg": "e66f",
	"./CM.svg": "6aed",
	"./CN.svg": "3238",
	"./CO.svg": "91bd",
	"./CR.svg": "020a",
	"./CU.svg": "d072",
	"./CV.svg": "98e4",
	"./CW.svg": "e505",
	"./CX.svg": "30c8",
	"./CY.svg": "1d76",
	"./CZ.svg": "542d",
	"./DE.svg": "c809",
	"./DJ.svg": "379c",
	"./DK.svg": "09e6",
	"./DM.svg": "6efd",
	"./DO.svg": "613b1",
	"./DZ.svg": "af6f",
	"./EC.svg": "1ad4",
	"./EE.svg": "af1d",
	"./EG.svg": "abe3",
	"./EH.svg": "2e78",
	"./ER.svg": "0b30",
	"./ES-CT.svg": "c145",
	"./ES.svg": "709c",
	"./ET.svg": "974f",
	"./EU.svg": "484b",
	"./FI.svg": "99d2",
	"./FJ.svg": "d50f",
	"./FK.svg": "47ab",
	"./FM.svg": "942c",
	"./FO.svg": "92fb",
	"./FR.svg": "9a62",
	"./GA.svg": "ba4e",
	"./GB-ENG.svg": "3012",
	"./GB-NIR.svg": "a776",
	"./GB-SCT.svg": "3004",
	"./GB-WLS.svg": "7e5c",
	"./GB.svg": "04ac",
	"./GD.svg": "d35e",
	"./GE.svg": "ee6e",
	"./GF.svg": "1d4f",
	"./GG.svg": "699a",
	"./GH.svg": "3a07",
	"./GI.svg": "5f35",
	"./GL.svg": "398c",
	"./GM.svg": "b56a",
	"./GN.svg": "ed78",
	"./GP.svg": "2d01",
	"./GQ.svg": "0c8d",
	"./GR.svg": "171c",
	"./GS.svg": "b8a9",
	"./GT.svg": "cf85",
	"./GU.svg": "0135",
	"./GW.svg": "8def",
	"./GY.svg": "b572",
	"./HK.svg": "41cf",
	"./HM.svg": "2197",
	"./HN.svg": "a958",
	"./HR.svg": "c9c7",
	"./HT.svg": "79dc",
	"./HU.svg": "300b",
	"./IC.svg": "f149",
	"./ID.svg": "4411",
	"./IE.svg": "afbae",
	"./IL.svg": "39f2",
	"./IM.svg": "a7cb",
	"./IN.svg": "9815",
	"./IO.svg": "ae21",
	"./IQ.svg": "d451",
	"./IR.svg": "9d76",
	"./IS.svg": "173e",
	"./IT.svg": "6344",
	"./JE.svg": "a4b6",
	"./JM.svg": "0d41",
	"./JO.svg": "1768",
	"./JP.svg": "3c76",
	"./KE.svg": "cf04",
	"./KG.svg": "bef0",
	"./KH.svg": "5cb9",
	"./KI.svg": "601e",
	"./KM.svg": "fd6a",
	"./KN.svg": "3529",
	"./KP.svg": "061b",
	"./KR.svg": "aeac",
	"./KW.svg": "ccda",
	"./KY.svg": "0faa",
	"./KZ.svg": "7076",
	"./LA.svg": "68a6",
	"./LB.svg": "1e85",
	"./LC.svg": "9675",
	"./LI.svg": "760b",
	"./LK.svg": "81d9",
	"./LR.svg": "5e93",
	"./LS.svg": "aebc",
	"./LT.svg": "e1d6",
	"./LU.svg": "bcd7",
	"./LV.svg": "e7df",
	"./LY.svg": "2476",
	"./MA.svg": "3a91",
	"./MC.svg": "ed66",
	"./MD.svg": "7816",
	"./ME.svg": "0cfe",
	"./MF.svg": "2c17",
	"./MG.svg": "1252",
	"./MH.svg": "a16c",
	"./MK.svg": "27fe",
	"./ML.svg": "112f",
	"./MM.svg": "de59",
	"./MN.svg": "4880",
	"./MO.svg": "caa2",
	"./MP.svg": "cb90",
	"./MQ.svg": "95d4",
	"./MR.svg": "d9a3",
	"./MS.svg": "04c8",
	"./MT.svg": "083d",
	"./MU.svg": "472f",
	"./MV.svg": "5776",
	"./MW.svg": "f35f",
	"./MX.svg": "e06f",
	"./MY.svg": "ad14",
	"./MZ.svg": "80c5",
	"./NA.svg": "6e92",
	"./NC.svg": "3661",
	"./NE.svg": "28ac",
	"./NF.svg": "8274",
	"./NG.svg": "97c4",
	"./NI.svg": "84e0",
	"./NL.svg": "4e31",
	"./NO.svg": "3b83",
	"./NP.svg": "018c",
	"./NR.svg": "a0a1",
	"./NU.svg": "9a0d",
	"./NZ.svg": "1f66",
	"./OM.svg": "77e2",
	"./PA.svg": "9936",
	"./PE.svg": "960a",
	"./PF.svg": "87bc",
	"./PG.svg": "5fb8",
	"./PH.svg": "94ed",
	"./PK.svg": "2437",
	"./PL.svg": "ed23",
	"./PM.svg": "9924",
	"./PN.svg": "202d",
	"./PR.svg": "a746",
	"./PS.svg": "9205",
	"./PT.svg": "1c07",
	"./PW.svg": "bc0e",
	"./PY.svg": "76e3",
	"./QA.svg": "f217",
	"./RE.svg": "5d30",
	"./RO.svg": "7515",
	"./RS.svg": "1111",
	"./RU.svg": "c541",
	"./RW.svg": "eee0",
	"./SA.svg": "f309",
	"./SB.svg": "7d5e",
	"./SC.svg": "2e89",
	"./SD.svg": "657f",
	"./SE.svg": "1462",
	"./SG.svg": "6e97",
	"./SH.svg": "bc0a",
	"./SI.svg": "fc1b",
	"./SJ.svg": "5722",
	"./SK.svg": "af86",
	"./SL.svg": "81f2",
	"./SM.svg": "f416",
	"./SN.svg": "f5a9",
	"./SO.svg": "ff14",
	"./SR.svg": "a84c",
	"./SS.svg": "cd0e",
	"./ST.svg": "1568",
	"./SV.svg": "9cd0",
	"./SX.svg": "f39d",
	"./SY.svg": "1025",
	"./SZ.svg": "e9fb",
	"./TA.svg": "2722",
	"./TC.svg": "309f",
	"./TD.svg": "9f66",
	"./TF.svg": "3e83",
	"./TG.svg": "b0bd",
	"./TH.svg": "9af1",
	"./TJ.svg": "f005",
	"./TK.svg": "dc1d",
	"./TL.svg": "acfd",
	"./TM.svg": "4e0f",
	"./TN.svg": "d604",
	"./TO.svg": "8eee",
	"./TR.svg": "fb17",
	"./TT.svg": "31d9",
	"./TV.svg": "9830",
	"./TW.svg": "3898",
	"./TZ.svg": "e17f",
	"./UA.svg": "1610",
	"./UG.svg": "7d9a",
	"./UM.svg": "0aac7",
	"./US.svg": "0aef",
	"./UY.svg": "aba9",
	"./UZ.svg": "8ce4",
	"./VA.svg": "ae78",
	"./VC.svg": "bef7",
	"./VE.svg": "c34c",
	"./VG.svg": "0e6b2",
	"./VI.svg": "33f0",
	"./VN.svg": "175c",
	"./VU.svg": "3587",
	"./WF.svg": "d9bb",
	"./WS.svg": "89d7",
	"./XA.svg": "14d6",
	"./XC.svg": "edc8",
	"./XK.svg": "8669",
	"./XO.svg": "bde9",
	"./YE.svg": "f103",
	"./YT.svg": "eff6",
	"./ZA.svg": "dd9f",
	"./ZM.svg": "a727",
	"./ZW.svg": "4349"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1c2";